module.exports = __webpack_public_path__ + "img/77ne.3b021612.svg";